import { luscinia } from "./luscinia";
import moment from 'moment-timezone';
import { RolePanel } from './rolePanel/rolePanel';
import { CallPanel } from './CallPanel/CallPanel';

// Initialize luscinia object with some configuration objects, config obj is mostly used for localization at this time
luscinia.Init = async function (config: Config) {
    addCustomEventListeners();
    updateRouteLocalStorage();

    //Overwrites config settings if passed in Init function
    if (config) {
        Object.keys(config).map(function (key, index) {
            (luscinia.config as any)[key] = (config as any)[key];
        });
    }

    localStorage.setItem("luscinia-config", JSON.stringify(config))

    // Set moment default timezone
    moment.tz.setDefault(config.timeZone);
    let modulePath: string = $('#notificationsRead').data(luscinia.data.modulePath);
    if (modulePath !== null && modulePath !== undefined && !modulePath.endsWith("/")) {
        modulePath += "/";
    }
    if (!luscinia.config.ignoreMessages) {
        let initMessages = function () {
            $('#notificationsRead').click(function () {
                //Set messages to read
                $.get(modulePath + "NotificationsRead");
                //If the user opened the dropdown, then initialize nanoscroller
                setTimeout(function () {
                    if ($('#messageList').hasClass('open')) {
                        $('#messageList .nano').nanoScroller();
                    }
                }, 0);
            });
        };
        initMessages();
    }
    await initInlineModal();
    
    luscinia.initBootgrids(config);

    luscinia.initWizard();

    luscinia.initUpdateJobOverview();

    if(luscinia.config.showJobNotifications){
        luscinia.initJobNotifications();
    }

    initRolePanel();
    initCallPanel();
};

function addCustomEventListeners() {
    document.addEventListener('modalRendered', (event: Event) => {
        const e = event as CustomEvent<ModalRenderedDetail>;
        const recordTableName = e.detail.recordTableName;
        if (recordTableName.toLowerCase() === "customers") {
            const modal = document.querySelector(e.detail.modalIdentifier);
            const recordId = modal.querySelector('form').dataset.lusciniaRecordId;
            (window as any).initRelatedActions(recordId, recordTableName, "RelatedActions", true);
        }
    });

    document.addEventListener('lusciniaModalSaved', (event: Event) => {
        const e = event as CustomEvent<{ formData: FormData, recordName: string, recordId: string }>;
        const formData = e.detail.formData;

        if (e.detail.recordName === "customers") {
            let recordId = formData.get("Id").toString();
            if (recordId === "00000000-0000-0000-0000-000000000000") {
                recordId = e.detail.recordId;
            }
            const hasCreateInvoiceEventEmailCreatedInvoiceJob: boolean = formData.get("CreateInvoiceEventEmailCreatedInvoiceJobModal") !== null;
            const hasPriceChangeEventEmailPriceChangeJob: boolean = formData.get("PriceChangeEventEmailPriceChangeJobModal") !== null;
            $.post("/data/JobEventHandlerMembers/SetMember", { addMember: hasCreateInvoiceEventEmailCreatedInvoiceJob, eventHandlerId: formData.get("CreateInvoiceEventEmailCreatedInvoiceJobModalHandlerId").toString(), recordId: recordId });            
            $.post("/data/JobEventHandlerMembers/SetMember", { addMember: hasPriceChangeEventEmailPriceChangeJob, eventHandlerId: formData.get("PriceChangeEventEmailPriceChangeJobModalHandlerId").toString(), recordId: recordId });            
        }
    });      
}
luscinia.renderWizard = function (wizardParameterFullName: string, config: Config): JQuery.jqXHR {
    return $.get(`/wizard/${wizardParameterFullName}/render`, function (response) {
        response = JSON.parse(response);
        $("#wizardcontainer").empty();
        $("#wizardcontainer").append(response.HtmlContent);
        localStorage.setItem("wizardState", response.WizardState);
    }).done(function(){
        luscinia.Init(config);
    });
}
// Set sort order from bootgrid
luscinia.setSortOrder = function (url, tableId) {
    $.ajax({
        type: 'GET',
        url: url.toLowerCase(),
        success: function (data) {
            ($("#" + tableId) as any).bootgrid("reload");
        }
    });
};
// Set sort order from bootgrid
luscinia.toggleBootgridCheckbox = function (url, tableId) {
    $.ajax({
        type: 'GET',
        url: url.toLowerCase(),
        success: function (data) {
            ($("#" + tableId) as any).bootgrid("reload");
        }
    });
};
async function initInlineModal() {
    const editInlines = document.querySelectorAll("[id='editInline']") as NodeListOf<HTMLElement>;
    const params = new URLSearchParams(new URL(window.location.href).search.slice(1));
    for (const editInline of editInlines) {
        const url = editInline.dataset.lusciniaUrl;
        if (url !== undefined) {
            if (params.toString() === "") {
                params.append("action", "new");
            }
    
            try {
                const response = await fetch(url + "/inlineedit?" + params.toString());
                const data = await response.text();
                editInline.querySelector("#editInlineContent").innerHTML = data;
    
                const editInlineForm = editInline.querySelector("form") as HTMLFormElement;
                const editModal = editInline.querySelector("[id*='editModal']");
                luscinia.initModalDialog($(editInlineForm) as JQuery<HTMLFormElement>, "#" + editModal.getAttribute('id'), luscinia.config, getActionFromUrl(url), undefined, true);
                luscinia.initUpdateJobOverview();
            } catch (error) {
                luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationForbidden, "danger");
            }
        } else {
            const editInlineForm = editInline.querySelector("form");
            const editModal = editInline.querySelector("[id*='editModal']");
            luscinia.initModalDialog($(editInlineForm) as JQuery<HTMLFormElement>, "#" + editModal.getAttribute('id'), luscinia.config, getActionFromUrl(url), undefined, true);
        }

        document.dispatchEvent(new CustomEvent<{ record: string }>('lusciniaInlineModalRendered', {
            detail: {
                record: url.replace('/data/', ''),
            }
        }));
    }
};
luscinia.openNewRecordModal = function (bootgrid: JQuery<HTMLTableElement>, config: Config, options?: { [key: string]: string }) {
    const newButton = bootgrid.closest(".table-container").find("[data-" + luscinia.data.action + "='record-new']");

    let menuItemId = bootgrid.data(luscinia.data.menuItemId);
    let urlBase = bootgrid.data(luscinia.data.modalUrl);

    if (urlBase === undefined || urlBase === "") {
        urlBase = bootgrid.data(luscinia.data.baseUrl);
    }

    let subInit = "";
    let layerId = luscinia.getModalLayerCount();
    let parentBootgrid = $("." + luscinia.css.bootgrid + "[data-" + luscinia.data.filterColumnName + "='']");
    let modalIdentifier = "#editModal" + layerId;

    // If parent bootgrid was detected use it to get the value
    if (parentBootgrid.length > 0) {
        let rows = parentBootgrid.find("tr." + luscinia.css.rowSelected);
        if (rows.length !== 0) {
            let parentFilterColumnName = bootgrid.data(luscinia.data.parentFilterColumnName);
            let rowid = $(rows[0]).data("row-id");

            if (parentFilterColumnName !== undefined && parentFilterColumnName !== "") {
                // Get key column name
                let keyColumnName = parentBootgrid.data(luscinia.data.keyColumnName);
                // Select row inside parent bootgrid
                let currentRows = (parentBootgrid as any).bootgrid("getCurrentRows");
                let selectedRow = $.grep(currentRows, function (e: any) {
                    return e[keyColumnName] === rowid;
                });
                if (selectedRow !== undefined && selectedRow.length > 0) {
                    rowid = selectedRow[0][parentFilterColumnName];
                }
            }

            subInit = `&filtercolumnname=${bootgrid.data(luscinia.data.filterColumnName)}&parentid=${rowid}`;
        }
    } else {
        // If not look for a property matching the property name
        let primaryKeyColumnName = bootgrid.data(luscinia.data.filterColumnName);
        let primaryKeyPropertyName = bootgrid.data("luscinia-parentfiltercolumnname");

        if (primaryKeyPropertyName !== null && primaryKeyPropertyName != undefined) {
            let idValue = $("#editInline").find(`[name='${primaryKeyPropertyName}']`).val();
            if (idValue === undefined) {
                primaryKeyPropertyName = $("#editInline .edit-modal").attr("primaryKeyPropertyName");
                idValue = $("#editInline").find(`[name='${primaryKeyPropertyName}']`).val();
            }
            subInit = `&filtercolumnname=${primaryKeyColumnName}&parentid=${idValue}`;
        }
    }

    if (newButton !== null && newButton !== undefined) {
        $(newButton).prop("disabled", true);
    }

    const url = new URL(urlBase + "/modaledit", window.location.origin);
    url.searchParams.set("action", "new");
    url.searchParams.set("bootgridId", "bootGrid" + menuItemId);
    url.searchParams.set("layerid", String(layerId));

    if (subInit) {
        const subParams = new URLSearchParams(subInit);
        subParams.forEach((value, key) => {
            url.searchParams.set(key, value);
        });
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            url.searchParams.set(key, value);
        }
    }

    return $.get(url.toString(), function (data) {
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, config, getActionFromUrl(url.toString()));
        $(modalIdentifier).modal("show");

        const inputEls = document.querySelectorAll("input[type=file]") as NodeListOf<HTMLInputElement>;
        if (inputEls != null) {
            addInputFieldEventListeners(inputEls);
        }
    })
        .fail(function () {
            luscinia.showNotification(
                luscinia.config.translations.captionNotification,
                luscinia.config.translations.captionNotificationForbidden,
                "danger"
            );
        })
        .always(function () {
            if (newButton !== null && newButton !== undefined) {
                setTimeout(() => {
                    $(newButton).prop("disabled", false);
                }, 200);
            }
        });

    function createTextInputField(file: File, index: number) {
        let fileName = file.name;
        let textInputEl = document.createElement("input");
        textInputEl.setAttribute("type", "text");
        textInputEl.setAttribute("id", "editModal0Form-luscinia-forminput-newfilename");
        textInputEl.setAttribute("name", `FileNameOverride-${index}`);
        textInputEl.setAttribute("value", fileName);
        textInputEl.value = fileName;

        textInputEl.addEventListener("change", function () {
            textInputEl.setAttribute("value", textInputEl.value);
        });
        return textInputEl;
    }

    function addInputFieldEventListeners(inputEls: NodeListOf<HTMLInputElement>) {
        inputEls.forEach(function (element, i) {
            element.addEventListener("change", function () {
                if (element.files.length != 1) return;
                let textInputEl = createTextInputField(element.files[0], i);
                insertAfter(textInputEl, element);
            });
        });
    }
};

function initRolePanel() {
    if (document.getElementById("RoleControlPanel") !== null) {
        new RolePanel().init();
    }
}

function initCallPanel() {
    if (document.getElementById("CallControlPanel") !== null) {
        new CallPanel().init();
    }
}

function updateRouteLocalStorage() {
    const isCurrentRouteEmpty = localStorage.getItem("currentRoute") === null;
    const isPreviousRouteSameAsCurrent = localStorage.getItem("currentRoute") === window.location.pathname;
    if (!isCurrentRouteEmpty && !isPreviousRouteSameAsCurrent) {
        localStorage.setItem("previousRoute", localStorage.getItem("currentRoute"));
    }
    localStorage.setItem("currentRoute", window.location.pathname);
}

export function reloadRecordModal(sender: HTMLElement, recordId: string) {
    const modal = sender.closest(".modal.edit-modal");
    const modulePath = modal.querySelector("form").dataset.lusciniaModulepath;
    const layerId = luscinia.getModalLayerCount() - 1;

    const url = modulePath + "/modaledit?action=edit&id=" + recordId + "&layerid=" + layerId;
    $.get(url, function (data) {
        const modalBodyContent = $(data).html();
        $(modal).html(modalBodyContent);
        const form = $(modal).find("form");
        luscinia.initModalDialog(form, '#' + modal.id, luscinia.config, getActionFromUrl(url));
    }).fail(function () {
        luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationForbidden, "danger");
    })
}

export interface ModalRenderedDetail {
    recordTableName: string;
    modalIdentifier: string;
}

function insertAfter(newNode: Node, referenceNode: Node) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function getActionFromUrl(url: string): string {
    return new URLSearchParams(url.split("?")[1]).get("action");
}

export function getConfig(): Config {
    return JSON.parse(localStorage.getItem("luscinia-config"));
}